import {
  getGoodsRemarkListApi,
  addGoodsRemarkApi,
  deleteGoodsRemarkApi,
  queryOrderCollectionApi,
  queryOrderRefundDetailApi,
  acceptRefundApi,
  refuseRefundApi,
  addBrandOrderExtendConfigApi,
  deleteBrandOrderExtendConfigApi,
  updateBrandOrderExtendConfigApi,
  queryBrandOrderExtendConfigApi,
  getOrderAndDetailByOrderIdApi,
  cancleOrderApi,
  updateWriteOffCodeValidTimeApi,
  queryOrderOverlordTaskApi,
  checkOrderOverlordTaskApi,
  getOrderOverlordTaskByIdApi,
  queryShopOverlordBalanceWaterApi,
  printOrderApi,
  updateMiniAppShowStatusApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  获得备注列表信息
  async getGoodsRemarkListAction(context, param) {
    const res = await getGoodsRemarkListApi(param)
    return res
  },
  //  添加备注信息
  async addGoodsRemarkAction(context, param) {
    const res = await addGoodsRemarkApi(param)
    return res
  },
  //  删除备注信息
  async deleteGoodsRemarkAction(context, param) {
    const res = await deleteGoodsRemarkApi(param)
    return res
  },
  //  查询订单管理
  async queryOrderCollectionAction(context, param) {
    const res = await queryOrderCollectionApi(param)
    return res
  },
  //  查询退款/退货详情
  async queryOrderRefundDetailAction(context, param) {
    const res = await queryOrderRefundDetailApi(param)
    return res
  },
  //  同意退款
  async acceptRefundAction(context, param) {
    const res = await acceptRefundApi(param)
    return res
  },
  //  拒绝退款
  async refuseRefundAction(context, param) {
    const res = await refuseRefundApi(param)
    return res
  },
  //  添加品牌订单扩展配置
  async addBrandOrderExtendConfigAction(context, param) {
    const res = await addBrandOrderExtendConfigApi(param)
    return res
  },
  //  删除品牌订单扩展配置
  async deleteBrandOrderExtendConfigAction(context, param) {
    const res = await deleteBrandOrderExtendConfigApi(param)
    return res
  },
  //  更新品牌订单扩展配置
  async updateBrandOrderExtendConfigAction(context, param) {
    const res = await updateBrandOrderExtendConfigApi(param)
    return res
  },
  //  查询品牌订单扩展配置列表
  async queryBrandOrderExtendConfigAction(context, param) {
    const res = await queryBrandOrderExtendConfigApi(param)
    return res
  },
  //  配送信息
  async getOrderAndDetailByOrderIdAction(context, param) {
    const res = await getOrderAndDetailByOrderIdApi(param)
    return res
  },
  //  订单作废
  async cancleOrderAction(context, param) {
    const res = await cancleOrderApi(param)
    return res
  },
  //  更新核销码有效时间
  async updateWriteOffCodeValidTimeAction(context, param) {
    const res = await updateWriteOffCodeValidTimeApi(param)
    return res
  },
  //  查询订单霸王任务
  async queryOrderOverlordTaskAction(context, param) {
    const res = await queryOrderOverlordTaskApi(param)
    return res
  },
  //  审核订单霸王任务
  async checkOrderOverlordTaskAction(context, param) {
    const res = await checkOrderOverlordTaskApi(param)
    return res
  },
  //  根据id获取询订单霸王任务
  async getOrderOverlordTaskByIdAction(context, param) {
    const res = await getOrderOverlordTaskByIdApi(param)
    return res
  },
  //  查询门店霸王余额流水
  async queryShopOverlordBalanceWaterAction(context, param) {
    const res = await queryShopOverlordBalanceWaterApi(param)
    return res
  },
  //  打印
  async printOrderAction(context, param) {
    const res = await printOrderApi(param)
    return res
  },
  //  更新订单显示状态
  async updateMiniAppShowStatusAction(context, param) {
    const res = await updateMiniAppShowStatusApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
